import type {
  DemoResetStepId,
  DemoResetWorkflowEvent,
  DemoResetWorkflowOutputs,
} from "../_shared/_logic/demo-data-reset-contract"

export const applyDemoResetWorkflowEvent = (
  outputs: DemoResetWorkflowOutputs,
  event: DemoResetWorkflowEvent,
): DemoResetWorkflowOutputs => {
  if (event.type === "profile_saved" && event.profile === "admin") {
    return { admin: event.output }
  }

  if (event.type === "profile_saved") {
    return { admin: outputs.admin, employee: event.output }
  }

  if (event.type === "profile_edit_requested" && event.profile === "admin") {
    return {}
  }

  if (event.type === "profile_edit_requested") {
    return { admin: outputs.admin }
  }

  if (event.type === "job_started") {
    return {
      admin: outputs.admin ? { ...outputs.admin, password: null } : undefined,
      employee: outputs.employee ? { ...outputs.employee, password: null } : undefined,
    }
  }

  return {
    admin: outputs.admin,
    employee: outputs.employee,
    reset: { result: event.result, downloadedFiles: ["admin", "employee"] },
  }
}

export const completedDemoResetSteps = (outputs: DemoResetWorkflowOutputs): DemoResetStepId[] => [
  ...(outputs.admin ? (["admin"] as const) : []),
  ...(outputs.employee ? (["employee"] as const) : []),
  ...(outputs.reset ? (["reset"] as const) : []),
]
